import React, { useState, useEffect } from "react";
import { Select, Form, Input, Checkbox } from "antd";
import { connect } from "react-redux";

import QADynamicTable from "../../../../components/qa_custom/DynamicTable";
import { selectDataFromExecQuery } from "../../actions/funcional.group";
import { getColumnSearchProps } from "../search.into.table.columns";

const { Option } = Select;
const EXEC_QUERY_NAME = {
    competencias_nec_grupos_func: "competencias_nec_grupos_func",
    tipos_competencias: "tipos_competencias",
    competencias: "competencias",
    todas_competencias: "todas_competencias",
};

const Competence = ({
    form,
    selectDataFromExecQuery, //from redux action
    soma_ponderacao_competencias,
    selectedGrupoExist,
    idGrupoExist,
    set_competencia_necessaria,
    competencia_necessaria,
    setCompetencePonderationCalculeValue,
}) => {
    const [dataSource, setDataSource] = useState([]);
    const [competenceTypes, setCompetenceTypes] = useState([]);
    const [competences, setCompetences] = useState([]);
    const [competenceTipeId, setCompetenceTypeId] = useState(undefined);
    const [sumPonderation, setSumPonderation] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (competencia_necessaria.length) {
            setDataSource(competencia_necessaria);
            setSumPonderation(!sumPonderation);
        }
    }, []);

    /**
     * do ponderation calcule
     */
    useEffect(() => {
        const sum = dataSource
            .filter((item) => item["ativo"] === "t")
            .map((item) => Number(item.ponderacao))
            .reduce((a, b) => a + b, 0);
        setCompetencePonderationCalculeValue(sum);
    }, [sumPonderation]);

    /**
     * fetch "competencias" from group exist
     */
    useEffect(
        () => {
            // if (selectedGrupoExist || idGrupoExist) {
            (async () => {
                setLoading(true);
                // const response = await selectDataFromExecQuery({
                //     query: EXEC_QUERY_NAME.competencias_nec_grupos_func,
                //     id_ficha_funcao: idGrupoExist || 0,
                //     sel_grupo_exist: selectedGrupoExist,
                // });
                // if (response.result) {
                //     if (Array.isArray(response.result)) {
                //         const data = [];
                //         response.result.forEach((item, index) => {
                //             data.push({ __key__: index, ...item });
                //         });
                //         await setDataSource(data);
                //         set_competencia_necessaria(data);
                //         setSumPonderation(!sumPonderation); // forcing calculate ponderation
                //     }
                // }

                /**
                 * get all competencias
                 */
                const req = await selectDataFromExecQuery({
                    query: EXEC_QUERY_NAME.todas_competencias,
                });
                if (req.result) {
                    if (Array.isArray(req.result)) {
                        setCompetences(req.result);
                    }
                }
                setLoading(false);
            })();
            // }
        },
        [
            /*selectedGrupoExist, idGrupoExist*/
        ]
    );

    /**
     * fetch "tipos competencias"
     */
    useEffect(() => {
        (async () => {
            const response = await selectDataFromExecQuery({
                query: EXEC_QUERY_NAME.tipos_competencias,
            });
            if (response.result) {
                if (Array.isArray(response.result)) {
                    setCompetenceTypes(response.result);
                }
            }
        })();
    }, []);

    /**
     * fetch "competencias"
     */
    // useEffect(() => {
    //     if (competenceTipeId) {
    //         (async () => {
    //             const response = await selectDataFromExecQuery({
    //                 query: EXEC_QUERY_NAME.competencias,
    //                 tipo_competencia: competenceTipeId,
    //             });
    //             if (response.result) {
    //                 if (Array.isArray(response.result)) {
    //                     setCompetences(response.result);
    //                 }
    //             }
    //         })();
    //     }
    // }, [competenceTipeId]);

    /**
     * add row to table
     */
    const addRowToTable = () => {
        let size = dataSource.length > 0 ? Math.max(...dataSource.map((item) => Number(item.__key__))) + 1 : 0;
        setDataSource([{ __key__: size }, ...dataSource]);
    };

    /**
     * remove row from table
     */
    const removeRowFromTable = (selectedRowKeys) => {
        const newDataSource = [];
        dataSource.forEach((item) => {
            if (!selectedRowKeys.includes(item.__key__)) newDataSource.push(item);
        });
        setDataSource(newDataSource);
        setSumPonderation(!sumPonderation);
    };

    /**
     * handle change when user enter degit
     */
    const onChange = async (dataIndex, value, record) => {
        const newState = [...dataSource];

        record[dataIndex] = value;
        const index = newState.findIndex((item) => item.__key__ === record.__key__);
        newState.splice(index, 1, record);
        // newState[index] = record;

        await setDataSource([...newState]);
        set_competencia_necessaria([...newState]);
        if (dataIndex === "ponderacao" || dataIndex === "ativo") {
            setSumPonderation(!sumPonderation);
        }
    };

    /**
     * columns to table
     */
    const columns = [
        {
            title: "Tipo de Competência",
            dataIndex: "tipo_competencia",
            width: "30%",
            ...getColumnSearchProps("tipo_competencia"),
            onFilter: (value, record) => {
                const filteredValue = competenceTypes
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.tipo_competencia);
                return filteredValue.includes(record["tipo_competencia"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "300px", margin: "0 auto", padding: "0" }}
                        placeholder="Seleciona uma opção"
                        optionFilterProp="children"
                        value={competenceTypes
                            .map((element) => element.tipo_competencia)
                            .find((item) => item === defaultValue)}
                        onChange={(value) => {
                            onChange("tipo_competencia", value, record);
                            setCompetenceTypeId(value);
                        }}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {competenceTypes.map((item) => (
                            <Option key={item.tipo_competencia} value={item.tipo_competencia}>
                                {item.designacao}
                            </Option>
                        ))}
                    </Select>
                );
            },
        },
        {
            title: "Designação",
            dataIndex: "competencia",
            width: "30%",
            ...getColumnSearchProps("competencia"),
            onFilter: (value, record) => {
                const filteredValue = competences
                    .filter((item) => item.designacao.toString().toLowerCase().includes(value.toLowerCase()))
                    .map((item) => item.competencia);
                return filteredValue.includes(record["competencia"]);
            },
            render: (text, record) => {
                const defaultValue = typeof text !== "object" && text ? text : undefined;

                return (
                    <Select
                        showSearch
                        allowClear
                        dropdownMatchSelectWidth={false}
                        style={{ maxWidth: "300px", margin: "0 auto", padding: "0" }}
                        placeholder="Seleciona uma opção"
                        optionFilterProp="children"
                        value={competences.map((element) => element.competencia).find((item) => item === defaultValue)}
                        onChange={(value) => onChange("competencia", value, record)}
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {competences
                            .filter((item) => item.tipo_competencia === record.tipo_competencia)
                            .map((item) => {
                                return (
                                    <Option key={item.competencia} value={item.competencia}>
                                        {item.designacao}
                                    </Option>
                                );
                            })}
                    </Select>
                );
            },
        },
        {
            title: "Ponderação",
            dataIndex: "ponderacao",
            width: "20%",
            ...getColumnSearchProps("ponderacao"),
            render: (text, record) => (
                <Form.Item style={{ width: "100%", margin: "0 auto", padding: "0" }}>
                    <Input
                        onChange={(e) => onChange("ponderacao", e.target.value, record)}
                        type="number"
                        defaultValue={typeof text !== "object" ? text : undefined}
                        style={{ width: "100%" }}
                        placeholder="Introduza a ponderação"
                    />
                </Form.Item>
            ),
        },
        {
            title: "Contribui QV?",
            dataIndex: "contribui",
            width: "10%",
            align: "center",
            ...getColumnSearchProps("contribui"),
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => onChange("contribui", e.target.checked === true ? "t" : "f", record)}
                    defaultChecked={text === "t" || text === true}
                />
            ),
        },
        {
            title: "Ativo?",
            dataIndex: "ativo",
            width: "10%",
            align: "center",
            ...getColumnSearchProps("ativo"),
            render: (text, record) => (
                <Checkbox
                    onChange={(e) => onChange("ativo", e.target.checked === true ? "t" : "f", record)}
                    defaultChecked={text === "t" || text === true}
                />
            ),
        },
    ];

    return (
        <>
            <QADynamicTable
                data={dataSource}
                columns={columns}
                addRowToTable={addRowToTable}
                onRemoveItem={removeRowFromTable}
                loadingData={loading}
            />
        </>
    );
};

const mapDispatchToProps = {
    selectDataFromExecQuery,
};

export default connect(null, mapDispatchToProps)(Competence);
